import { render, staticRenderFns } from "./VComponent.vue?vue&type=template&id=002465d2&scoped=true&"
import script from "./VComponent.vue?vue&type=script&lang=js&"
export * from "./VComponent.vue?vue&type=script&lang=js&"
import style0 from "./VComponent.vue?vue&type=style&index=0&id=002465d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002465d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002465d2')) {
      api.createRecord('002465d2', component.options)
    } else {
      api.reload('002465d2', component.options)
    }
    module.hot.accept("./VComponent.vue?vue&type=template&id=002465d2&scoped=true&", function () {
      api.rerender('002465d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/inventory-items/components/history-table/VComponent.vue"
export default component.exports